import { Store } from 'pullstate';
export const default_bo_booking_form_store = {
  discount_code_data: {},
  discount_code: '',
  status_messages: {}
};
const BoBookingFormStore = new Store(default_bo_booking_form_store);
export default BoBookingFormStore;
